import { render, staticRenderFns } from "./SettingsFormLooking.vue?vue&type=template&id=5caf0c3e&"
import script from "./SettingsFormLooking.vue?vue&type=script&lang=js&"
export * from "./SettingsFormLooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports